function setAutomaticAssignmentsHandler(draft, action) {
    const assignments = action.payload.assignments;
    for (let datum of assignments) {
        const index = draft.data.findIndex((spectrum) => spectrum.id === datum.id);
        if (index !== -1) {
            const dimension = draft.data[index].info.dimension;
            if (dimension === 1) {
                draft.data[index].ranges.values = datum
                    .ranges;
            }
            else if (dimension === 2) {
                draft.data[index].zones.values = datum
                    .zones;
            }
        }
    }
}
export { setAutomaticAssignmentsHandler };
